export const SIGN_UP_TOTAL_STEPS = 4;
